/**
 * **WARNING:** use only if you are sure that `.find()` return something
 */
const confidentFind = <T>(array: T[], ...props: Parameters<Array<T>['find']>): T => array.find(...props) as T;

export default confidentFind;
